import React, { Component } from 'react'
import MUIDataTable from "mui-datatables";
import { IconButton, Dialog, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@material-ui/core';
import Launch from '@material-ui/icons/Launch';
import Add from '@material-ui/icons/Add';
import { GetData,PostData } from '../../api/service';
import  {toast} from 'react-toastify'


export default class StockTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoaded: false,
            show:false
           
        }
    }



    handleDelete(rowsDeleted) {
        console.log(rowsDeleted)
    }

    onActionClick(el) {
        this.props.actionClick(el);
    }

    onClick() {
        console.log("hey");
    }

    onActiveClick(el) {
       
        if(el.status == 1){
            toast.info('You have already sent the money.');
            this.setState({
                show: false,
                status:true
            })
        }
        else{

        this.setState({
            show: true,
            send_data: el
        })
    }
    }

    handleClose = () => {
        this.setState({
            show: false,
            send_data: ''
        }, () => {
            this.props.refreshData();
        })
    }

    getStatus = (value) => {
        if (value === 1) {
            return 'Sent';
        } else if (value === 0) {
            return 'Pending';
        }

        else if (value === 2) {
            return 'Rejected';
        }
    }

    bankDetails = (el) => {
        if(el.account_no !== ''){
            return (

                `A/C No: ${el.account_no} \n A/C Holder: ${el.account_holder_name} \n Bank: ${el.bank} \n Branch: ${el.branch} \n IFSC: ${el.ifsc_code}`
    
            )
        }else{
            return null;
        }
        
    }



    render() {
        const columns = [
            {
                name: "#",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Type",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "User Id",
                options: {
                    filter: true,
                    sort: true,
                }
            },

            {
                name: "Request Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },

            {
                name: "Send Date",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Purpose",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Amount",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Status",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Bank Details",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "Send/Reject",
                options: {
                    filter: false,
                    sort: false,
                    download: false
                }
            },
            {
                name: "Action",
                options: {
                    filter: false,
                    sort: false,
                    download: false
                }
            }
        ];

        const options = {
            filterType: 'checkbox',
            selectableRows: false,
            responsive: 'scroll',
            onRowsDelete: (rowsDeleted) => {
                this.handleDelete(rowsDeleted)
            },
            customToolbar: () => {
                return (
                    <IconButton onClick={this.props.onAddClick}>
                        <Add />
                    </IconButton>
                )
            }
        };

        let data = [];
        let table_data = this.props.table_data;
        if (Array.isArray(table_data) && table_data.length > 0) {
            data = table_data.map((el, index) =>
                [index + 1,el.request_type == 2 ? "MAIN_WALLET" : "REPURCHASE WALLET", el.user_id, el.request_date,el.send_date, el.narration,el.amount, this.getStatus(el.status),this.bankDetails(el),<Launch onClick={this.onActiveClick.bind(this,el)} />, <Launch onClick={this.onActionClick.bind(this, el)} />]
            )
        } else {
            data = [];
        }

        return (
            <div>
                <MUIDataTable
                    title={"Money Transfers"}
                    data={data}
                    columns={columns}
                    options={options}

                />

                {this.state.show ? (<DialogStatus
                    open={this.state.show}
                    id={this.state.send_data.id}
                    handleClose={this.handleClose}
                />) : null}
            </div>
        )


    }
}


class DialogStatus extends Component {


    handleListItemClick = (id, value) => {
        let d = {
            id: id,
            status: value
        }

        PostData(`/quicktransfer`, d)
        .then((resp) => {
            //console.log(resp);
            this.props.handleClose();
        })
    }
    render() {
        const stat = [
            {
                title: 'Send Money',
                value: 1
            },
            {
                title: 'Reject Request',
                value: 2
            }
        ]
        return (
            <div>
                <Dialog onClose={this.props.handleClose} open={this.props.open}>
                    <DialogTitle>Transaction</DialogTitle>
                    <List>
                        {stat.map((el,index) => (
                            <ListItem key={index} button onClick={() => this.handleListItemClick(this.props.id,el.value)}>
                                <ListItemAvatar>
                                    <Avatar>
                                        {el.value}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={el.title} />
                            </ListItem>
                        ))}
                    </List>
                </Dialog>
            </div>
        )
    }
}
